<template>
  <div>
    <click-to-edit
      v-model="scale.plan"
      :disabled="disabled"
      placeholder=""
      digits-only
      @input="$emit('change', scale.plan)"
    ></click-to-edit>
  </div>
</template>

<script>

import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";
import ClickToEdit from "@/components/ClickToEdit";

export default {
  name: "quantity-card-plan-view",
  mixins: [dynamicScaleComponent],
  components: {ClickToEdit},

  props: {
    disabled:{type: Boolean, default: false}
  },
  data() {
    return {
      scale:{
        plan: null,
      },
    }
  },
  methods: {}
}
</script>